'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = forEach;

var _objectType = require('./objectType');

/**
 * @param {Object} object 需要循环的对象 可以是 Object、Array
 * @param {Function} fn 回调
 * 如果回调返回了false：则结束此次循环
 * @return {Object} object
 */
function forEach(object, fn) {
    if ((0, _objectType.isFunction)(fn)) {
        var res = void 0;
        if ((0, _objectType.isArray)(object) || (0, _objectType.isNodeList)(object)) {
            for (var i = 0, l = object.length; i < l; i++) {
                res = fn(object[i], i);
                if ((0, _objectType.isBoolean)(res) && !res) {
                    break;
                }
            }
        } else if ((0, _objectType.isObject)(object)) {
            for (var o in object) {
                if (object.hasOwnProperty(o)) {
                    res = fn(object[o], o);
                    if ((0, _objectType.isBoolean)(res) && !res) {
                        break;
                    }
                }
            }
        }
    }
    return object;
} /**
   * forEach 循环指定的对象、数组
   */


//////////////////
// WEBPACK FOOTER
// ./src/lib/utils/forEach.js
// module id = 66
// module chunks = 0